export var getNextAvailableTabLeftDirection = function getNextAvailableTabLeftDirection(index, tabListLength, children) {
  var i = index;

  do {
    if (i > 0) {
      i -= 1;
    } else {
      i = tabListLength;
    }
  } while (children[i].props.disabled); // Skip disabled tabs


  return i;
};
export var getNextAvailableTabRightDirection = function getNextAvailableTabRightDirection(index, tabListLength, children) {
  var i = index;

  do {
    if (i < tabListLength) {
      i += 1;
    } else {
      i = 0;
    }
  } while (children[i].props.disabled); // Skip disabled tabs


  return i;
};